import { aboutData } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-3">
              品牌故事
            </span>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-950">
              {aboutData.title}
            </h2>
            <p className="mt-2 text-lg text-primary-600 font-medium">
              {aboutData.subtitle}
            </p>
          </div>

          <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed mb-10">
            {aboutData.description.split('\n\n').map((para, idx) => (
              <p key={idx}>{para}</p>
            ))}
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
            {aboutData.stats.map((stat) => (
              <div
                key={stat.label}
                className="bg-background-100 rounded-xl p-5 text-center border border-background-200/70"
              >
                <div className="text-2xl md:text-3xl font-bold text-primary-500 mb-1">
                  {stat.value}
                </div>
                <div className="text-xs text-foreground-500">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}